import React from "react";
import { getClassName } from "@sscs/utils";
import FoundSummary from "../FoundSummary/FoundSummary";
import styles from "./filtersContainer.module.scss";
const FiltersContainer = ({ id, children, className, found, }) => {
    return (React.createElement("div", { id: id, className: getClassName(styles.container, className) },
        children,
        found ? React.createElement(FoundSummary, { ...found }) : null));
};
export default FiltersContainer;
//# sourceMappingURL=FiltersContainer.js.map